import { __awaiter } from "tslib";
import { EventsMap } from './eventsMap';
export class WebhookManager {
    constructor(subscriber, url, options = {}) {
        this.url = url;
        this.subscriber = subscriber;
        this.options = {
            tokenValue: options.tokenValue || '',
            tokenHeader: options.tokenHeader || '',
        };
        this.handlers = new EventsMap(subscriber.logger);
    }
    subscribe() {
        return this.subscriber.subscribeWebhook(this.url, this.options.tokenHeader, this.options.tokenValue);
    }
    unsubscribe() {
        return this.subscriber.unsubscribeWebhook(this.url);
    }
    handleIncomingEvents(httpHandler) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = httpHandler.getHeader(this.options.tokenHeader);
            if (this.options.tokenHeader !== '' && token !== this.options.tokenValue) {
                httpHandler.handleResponse(401, { message: 'Unauthorized' });
                return;
            }
            try {
                const events = httpHandler.getBody();
                events.forEach((event) => {
                    const handler = this.handlers.load(event.type);
                    if (handler) {
                        handler.emit(event.type, event.content);
                    }
                    else {
                        this.subscriber.logger.debug(`No handler registered for event type: ${event.type}`);
                    }
                });
                httpHandler.handleResponse(200);
            }
            catch (error) {
                if (error instanceof Error) {
                    this.subscriber.logger.error(error.message);
                }
                else {
                    this.subscriber.logger.error('Unknown error during event handling');
                }
                httpHandler.handleResponse(500, { message: 'error processing events' });
            }
        });
    }
    registerHandler(eventName, handlerFunction) {
        this.handlers.store(eventName, handlerFunction);
    }
}
